import { render } from "./NewArticleFooter.vue?vue&type=template&id=2c420882&scoped=true"
import script from "./NewArticleFooter.vue?vue&type=script&lang=js"
export * from "./NewArticleFooter.vue?vue&type=script&lang=js"

import "./NewArticleFooter.vue?vue&type=style&index=0&id=2c420882&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c420882"]])

export default __exports__